// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"981":"0a09e9e96dfb76d2f376","2898":"65cf682a53c33103d01b","7427":"6e196099ef8d8ecf4e01","9876":"2f43f3f9aa1722559766"}[chunkId] + ".css";
};